// extracted by mini-css-extract-plugin
module.exports = {"fragments":"segments-icons_fragments__n1aAg","fragmentsLetter":"segments-icons_fragmentsLetter__NjWRY"};